import _ from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';

import { Link } from 'react-router-dom';

import { Page } from '../shared';

import { currentUserRole, getSprintStatusTextForEmployee } from '../../util';
import { getIcon } from '../../util/icons';

class TeamDetailsPage extends Component {

  teamData(){
    if(!this.props.teams || this.props.teams.length === 0){
      return null;
    }

    const teamId = this.props.match.params.teamId;

    return _.find(this.props.teams, team => {
      return team._id === teamId;
    }) || null;
  }

  employeesMappedById(){
    const employees = this.props.employees;

    return _.keyBy(employees, '_id');
  }

  userData(userId){
    return this.employeesMappedById()[userId];
  }

  renderTeamLink(team){
    return <Link to={`/teams/${team._id}`} key={team._id} href="google.com">{team.name}</Link>
  }

  renderTeamDetails(){

    const team = this.teamData();

    if(!team){ return null; }

    console.log('attempting to render team: ', team);

    const linkedTeams = _.filter(this.props.teams, possiblyLinkedTeam => {
      //team is linked if it's leader is one of the current team's members
      return _.intersection(possiblyLinkedTeam.leaders, team.members).length > 0;
    });

    return (
      <div className="team">
        <div className="name">{team.name}</div>

        <h6>TEAM LEADER{team.leaders.length > 1 ? 'S' : ''}</h6>
        <ul>
          {_.map(team.leaders, leader => {
            const leaderData = this.userData(leader);

            return <Link key={leader} to={`/people/${leader}/sprint`}>
              <li className={(leaderData.currentSprintStatus === 'submitted' ? 'active' : '')}>
                <div className="member-name">{leaderData.firstName} {leaderData.lastName}</div>
                <div className={`sprint-status ${leaderData.currentSprintStatus}`}>{getSprintStatusTextForEmployee(leaderData.currentSprintStatus)}</div>
                <div className="hover-action">View Sprint</div>
              </li>
            </Link>
          }) }
        </ul>

        <h6>MEMBERS</h6>
        <ul>
          {_.map(team.members, member => {
            const memberData = this.userData(member);


            return <Link key={member} to={`/people/${member}/sprint`}>
              <li className={(memberData.currentSprintStatus === 'submitted' ? 'active' : '')}>
                <div className="member-name">{memberData.firstName} {memberData.lastName}</div>
                <div className={`sprint-status ${memberData.currentSprintStatus}`}>{getSprintStatusTextForEmployee(memberData.currentSprintStatus)}</div>
                <div className="hover-action">View Sprint</div>
              </li>
            </Link>
          })}
        </ul>

        {linkedTeams.length > 0 &&
          <div className="linked-teams">
            {getIcon('network')}
            <h6>MEMBER LED TEAMS</h6>
            <p>{_.map(linkedTeams, this.renderTeamLink)}</p>
          </div>
        }
      </div>
    )
  }

  render(){

    const loading = !this.teamData();

    if(!loading){
      console.log('found team data!!!');
    }

    return (
      <Page
        pageClass="team"
        loading={loading}
        hideSidebar={true}
      >
        <div className="teams-list-and-search">
          {this.renderTeamDetails()}
        </div>
      </Page>
    )
  }
}

function mapStateToProps(state){
  return {
    user: state.user,
    employees: state.employees.data,
    teams: state.teams.data,
  }
}

export default connect(mapStateToProps, {  })(TeamDetailsPage);



// WEBPACK FOOTER //
// ./src/components/teams/details.js